"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGasLow = isGasLow;
exports.setAutocompoundLowGasState = setAutocompoundLowGasState;
exports.getAutocompoundLowGasState = getAutocompoundLowGasState;
exports.manageState = manageState;
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const loopingProfitableCheck_js_1 = require("./loopingProfitableCheck.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
async function checkGasBalance() {
    const client = (0, alphafi_sdk_1.getSuiClient)();
    const suiBalances = (await client.getAllBalances({
        owner: (0, alphafi_sdk_1.getConf)().AUTOCOMPOUND_WALLET_ADDRESS,
    })).find((o) => o.coinType === "0x2::sui::SUI");
    return suiBalances ? parseFloat(suiBalances.totalBalance) / 1e9 : 0;
}
async function isGasLow() {
    const gasBalance = await checkGasBalance();
    return gasBalance < 100
        ? { gas: gasBalance, lowGas: true }
        : { gas: gasBalance, lowGas: false };
}
async function setAutocompoundLowGasState(state, gasBalance) {
    const tableName = process.env.HOLDERS_CONF_TABLE_NAME;
    const ddbClient = process.env.LOCAL_AWS
        ? new client_dynamodb_1.DynamoDBClient({ region: "local", endpoint: "http://localhost:8000" })
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        throw new Error("Table name not found from env");
    }
    const item = {
        id: "AutocompoundGasMonitor",
        lowGas: state,
        timestamp: Date.now(),
        gas: gasBalance,
    };
    const command = new lib_dynamodb_1.PutCommand({
        TableName: tableName,
        Item: item,
    });
    await ddbDocClient.send(command);
}
async function getAutocompoundLowGasState() {
    const tableName = process.env.HOLDERS_CONF_TABLE_NAME;
    const ddbClient = process.env.LOCAL_AWS
        ? new client_dynamodb_1.DynamoDBClient({ region: "local", endpoint: "http://localhost:8000" })
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        throw new Error("Table name not found from env");
    }
    const command = new lib_dynamodb_1.GetCommand({
        TableName: tableName,
        Key: {
            id: "AutocompoundGasMonitor",
        },
    });
    const result = await ddbDocClient.send(command);
    if (!result.Item) {
        return undefined;
    }
    return {
        lowGas: result.Item.lowGas,
        timestamp: new Date(result.Item.timestamp),
        gas: result.Item.gas,
    };
}
async function sendMessageAutocompoundMonitor(message) {
    const BOT_TOKEN = await (0, loopingProfitableCheck_js_1.getSecretValue)(process.env.AUTOCOMPOUND_MONITOR_BOT_TOKEN);
    const CHAT_ID = await (0, loopingProfitableCheck_js_1.getSecretValue)(process.env.AUTOCOMPOUND_MONITOR_GROUP_ID);
    const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
    const params = {
        chat_id: CHAT_ID,
        text: message,
    };
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
        if (!response.ok) {
            throw new Error(`Failed to send message: ${response.statusText}`);
        }
    }
    catch (error) {
        console.error("Error sending Telegram message:", error);
        throw error;
    }
}
async function manageState() {
    const lastState = await getAutocompoundLowGasState();
    const currentState = await isGasLow();
    if (lastState && lastState.gas < currentState.gas) {
        await sendMessageAutocompoundMonitor(`Gas added to autocompound wallet, balance set to ${currentState.gas} SUI`);
        await setAutocompoundLowGasState(currentState.lowGas, currentState.gas);
        return;
    }
    if (lastState && lastState.lowGas) {
        if (!currentState.lowGas) {
            await sendMessageAutocompoundMonitor(`Autocompound wallet gas no longer less, balance set to ${currentState.gas} SUI`);
            await setAutocompoundLowGasState(false, currentState.gas);
        }
        else if (((lastState.gas >= 25 || !lastState.gas) && currentState.gas < 25) ||
            ((lastState.gas >= 6 || !lastState.gas) && currentState.gas < 6)) {
            await sendMessageAutocompoundMonitor(`Autocompound wallet gas is very less, balance is ${currentState.gas} SUI`);
            await setAutocompoundLowGasState(true, currentState.gas);
        }
    }
    else {
        if (currentState.lowGas) {
            await sendMessageAutocompoundMonitor(`Autocompound wallet gas is less, balance is ${currentState.gas} SUI`);
            await setAutocompoundLowGasState(true, currentState.gas);
        }
    }
}
//# sourceMappingURL=autocompoundGasMonitor.js.map